import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Dumbbell, Wind, Flower2 } from 'lucide-react';

// Import your new separate files
import WorkoutSection from './WorkoutSection';
import MeditationSection from './MeditationSection';
import YogaSection from './YogaSection';

const WellnessApp = () => {
  const [activeTab, setActiveTab] = useState('workout');

  const tabs = [
    { id: 'workout', icon: Dumbbell, label: 'Workout' },
    { id: 'meditation', icon: Wind, label: 'Mind' },
    { id: 'yoga', icon: Flower2, label: 'Yoga' }
  ];

  return (
    /* Removed max-w-md to allow full-screen width; added max-w-7xl for desktop readability */
    <div className="min-h-screen bg-gray-50 w-full max-w-7xl mx-auto p-4 md:p-8 pb-24 lg:pb-8">
      
       {/* Header */}
      <div>
      <h2 className="text-2xl font-bold text-gray-900">Workout Plans</h2>
        <p className="text-gray-500 mt-1">
          AI-powered personalized training
        </p>
      </div>

      {/* Tabs - Centered and max-width restricted on large screens for better UI */}
      <nav className="flex bg-gray-200 rounded-2xl p-1 mb-8 max-w-lg mx-auto md:mx-0">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 flex flex-col items-center py-3 rounded-xl transition-all relative ${
                isActive ? 'text-emerald-600' : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              {/* Animated Background for active tab */}
              {isActive && (
                <motion.div
                  layoutId="active-pill"
                  className="absolute inset-0 bg-white shadow-sm rounded-xl"
                  transition={{ type: 'spring', duration: 0.5 }}
                />
              )}
              
              <Icon size={20} className="relative z-10" />
              <span className="text-[10px] font-bold uppercase mt-1 relative z-10">
                {tab.label}
              </span>
            </button>
          );
        })}
      </nav>

      {/* Content Switcher */}
      <main className="w-full">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
          >
            {activeTab === 'workout' && <WorkoutSection />}
            {activeTab === 'meditation' && <MeditationSection />}
            {activeTab === 'yoga' && <YogaSection />}
          </motion.div>
        </AnimatePresence>
      </main>
    </div>
  );
};

export default WellnessApp;